<template>
  <div class="main">
    <div class="container">
      <div class="back">
        <i class="iconfont icon-back pointer" style="color: #333;font-size: 24px" @click="handleBack()"></i>
      </div>
      <div class="form-wrap">
        <h2>修改密码</h2>
        <div class="form-wrap-tip"></div>
        <el-form :model="form" ref="form" :rules="rules">
          <el-form-item prop="loginName">
            <el-input v-model="form.loginName" placeholder="账号（手机号码）"></el-input>
          </el-form-item>


          <el-form-item prop="code">
            <div class="flex flex_align-items">
              <el-input v-model="form.code" placeholder="验证码"></el-input>
              <el-button :loading="loading" @click="getCode" type="primary" style="width: 120px;margin-left: 30px">{{ CODE_TEXT }}</el-button>
            </div>
          </el-form-item>

          <el-form-item prop="password">
            <el-input type="password" v-model="form.newPwd" placeholder="新密码"></el-input>
          </el-form-item>

          <el-form-item prop="queryPassword">
            <el-input type="password" v-model="form.queryPassword" placeholder="确认密码"></el-input>
          </el-form-item>

        </el-form>
        <div class="flex flex_align-items flex_justify-center" style="margin-top: 30px">
          <el-button type="primary" style="width: 60%" @click="handleForgetpwd('form')">立即重置</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    let checkPhone = (rule, value, callback) => { // 手机号码验证
      if (!value) {
        return callback(new Error('手机号码不能为空'));
      }
      setTimeout(() => {
        let patt = /^\d{11}$/;
        if (!patt.test(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
      }, 1000);
    };

    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if(value.length < 6) {
        callback(new Error('密码长度大于6位数'));
      } else {
        callback();
      }
    };

    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      form: {
        loginName: '', // 用户名
        newPwd: '', // 密码
        queryPassword: '', // 确认密码
        code: '', // 验证码
      },
      rules: {
        loginName: [
          { required: true, validator: checkPhone, trigger: ['blur', 'change'] },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: ['blur', 'change'] },
        ],
        newPwd: [
          { required: true, validator: validatePass, trigger: ['blur', 'change'] },
        ],
        queryPassword: [
          { required: true, validator: validatePass2, trigger: ['blur', 'change'] },
        ]
      },
      CODE_TEXT: '获取验证码',
      isGetCode: false,
    }
  },
  methods: {
    handleForgetpwd(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post(this.$API.MEMBER_FORGETPWD, {
            ...this.form
          }).then( res => {
            console.log(res)
            if(res.code === 200) {
              this.$message({
                message: '重置成功',
                type: 'success'
              });
              setTimeout(() => {
                for(let i in this.form) {
                  this.form[i] = '' // 初始化
                }
                this.$router.back()
              }, 1000)
            } else {
              this.$message.error(res.msg);
            };
          })
        } else return false;
      });
    },
    async getCode() { // 获取验证码
      // 为防止计时器增加
      if( this.isGetCode) return;
      // 验证
      if(!this.form.loginName) return this.$message.error('请输入手机号码');
      this.loading = true

      // 获取验证码
      let mobilePhone = await this.getMobilePhone(this.form.loginName)
      if(mobilePhone.code !== 200) return this.$message.error(mobilePhone.msg);
      else {
        this.$message({
          message: mobilePhone.msg,
          type: 'success'
        });
      };
      this.isGetCode = true;
      this.loading = false
      // 计时器 60
      let count = 60
      let timer = setInterval(() => {
        count--
        this.CODE_TEXT = count
        if (count === 0) {
          console.log(count)
          setTimeout(() => {
            this.CODE_TEXT = '获取验证码';
            this.isGetCode = false;
            clearInterval(timer);
          }, 100)
        }
      }, 1000)
    },
    getMobilePhone(loginName) { // 获取手机验证码
      return new Promise( resolve => {
        this.$post(this.$API.CODE, {
          loginName: loginName
        }).then( res => {
          resolve(res)
        })
      })
    },
    handleBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="scss">

.main {
  background: url(../../assets/restes-bg.png) no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  position: fixed;
  min-width: 1240px;

  .container {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 50%;
    border-radius: 10px;
    transform: translate(-50%,-50%);
    background: #FFFFFF;
    padding: 20px;

    .form-wrap {
      margin: $spacing-row-lg 30px;
      text-align: center;
      &-tip {
        border-bottom: 1px solid #999999;
        line-height: 50px;
        margin: $spacing-row-lg 0;
      }
    }

  }
}

.back {
  position: absolute;
}
</style>
